import React, { ReactElement } from 'react';
import styled, { css } from 'styled-components';
import { forIPhone5 } from '@westwing/ui-kit/breakPoints';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';
import { BellaTestIds } from 'Common/qaIds';

const Strikethrough = styled.span<{ sizeSelector?: boolean }>`
    color: ${({ theme }) => theme.colors.charcoal100};
    text-decoration: line-through;
    display: inline-block;
    margin-right: 10px;

    ${({ sizeSelector }) =>
        sizeSelector &&
        css`
            margin-right: 0;
        `}

    ${forIPhone5`
        margin-right: 0px;
    `}
`;

const DiscountPrice = styled.span<{ color?: string; sizeSelector?: boolean }>`
    color: ${({ theme, color }) => color || theme.colors.charcoal50};
    padding-left: 7px;
    ${({ sizeSelector }) =>
        sizeSelector &&
        css`
            padding-left: 0;
        `}
`;

const UVPText = styled.span`
    margin-right: 5px;
`;

interface Props {
    price: string;
    originalPrice: string;
    discountColor?: string;
    uvpText?: string;
    testId?: string;
    sizeSelector?: boolean;
    className?: string;
}

const SpecialPriceRenderer = ({
    price,
    originalPrice,
    discountColor,
    uvpText,
    testId = '',
    sizeSelector,
    className,
}: Props): ReactElement => {
    const featureToggles = useFeatureToggle();
    if ((featureToggles && featureToggles.specialPrice) || price !== originalPrice) {
        return (
            <span className={className}>
                {!!uvpText && <UVPText>{uvpText}</UVPText>}
                <Strikethrough sizeSelector={sizeSelector} data-testid={BellaTestIds.strikeThroughPrice}>
                    {originalPrice}
                </Strikethrough>
                <DiscountPrice sizeSelector={sizeSelector} data-testid={testId} color={discountColor}>
                    {price}
                </DiscountPrice>
            </span>
        );
    }

    return (
        <span className={className} data-testid={testId}>
            {price}
        </span>
    );
};

export default SpecialPriceRenderer;
